import { useCallback, useEffect, useRef, useState } from 'react';

import { getLiveAsNavForPartner } from '../../util/reactSlickNav';

/**
 * Owns live main/thumbnail react-slick instances for ProductImages asNavFor sync.
 * Dead partners (innerSlider cleared on unmount) are filtered via getLiveAsNavForPartner.
 * Thumbnail remounts refresh state through onMount; do not clear partners on activeProductId
 * in an effect (that races after the new keyed mount and can wipe the fresh instance).
 * The gallery root ref stops deferred notifications at detach, before passive cleanup.
 */
const useProductImageSliderNav = ({ isMobile }) => {
  const [mainImageSliderNav, setMainImageSliderNav] = useState(null);
  const [thumbnailSliderNav, setThumbnailSliderNav] = useState(null);
  const mountedRef = useRef(false);
  const galleryRef = useCallback((node) => {
    mountedRef.current = node !== null;
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setMainImageSliderNav(null);
    }
  }, [isMobile]);

  const onMainSliderMount = useCallback(({ innerRef }) => {
    if (mountedRef.current) {
      setMainImageSliderNav(innerRef);
    }
  }, []);

  const onThumbnailSliderMount = useCallback(({ innerRef }) => {
    if (mountedRef.current) {
      setThumbnailSliderNav(innerRef);
    }
  }, []);

  return {
    galleryRef,
    mainImageSliderNav,
    thumbnailSliderNav,
    mainAsNavFor: getLiveAsNavForPartner(mainImageSliderNav),
    thumbnailAsNavFor: getLiveAsNavForPartner(thumbnailSliderNav),
    onMainSliderMount,
    onThumbnailSliderMount,
  };
};

export default useProductImageSliderNav;
